<template>
  <div class="trading-conditions">
    <!-- Trading Conditions Header -->
    <div class="section-header">
      <h2 class="main-title">Trading Conditions</h2>
      <h3 class="subtitle">Empowering You for Effortless Earnings!</h3>
    </div>

    <!-- Trading Conditions Grid -->
    <div class="conditions-grid">
      <div class="grid-container">
        <div v-for="condition in tradingConditions" :key="condition.id" class="condition-card">
          <div class="icon-container">
            <svg class="condition-icon" :viewBox="condition.viewBox" xmlns="http://www.w3.org/2000/svg">
              <path :d="condition.pathData"></path>
            </svg>
          </div>
          <div class="content-container">
            <h4 class="condition-title">{{ condition.title }}</h4>
            <p class="condition-description">{{ condition.description }}</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TradingConditions',
  data() {
    return {
      tradingConditions: [
        {
          id: 1,
          title: 'Platform',
          description: 'MetaTrader5',
          viewBox: '0 0 640 512',
          pathData: 'M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z'
        },
        {
          id: 2,
          title: 'Spread',
          description: 'Floating, Start from Zero Pips',
          viewBox: '0 0 576 512',
          pathData: 'M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c123.712 0 224 100.288 224 224 0 35.65-8.31 69.28-23.13 99.2H87.13C72.31 389.28 64 355.65 64 320c0-123.712 100.288-224 224-224z'
        },
        {
          id: 3,
          title: 'Minimum Deposit',
          description: 'Start from 1,000$',
          viewBox: '0 0 640 512',
          pathData: 'M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z'
        },
        {
          id: 4,
          title: 'Currency',
          description: 'Bank & Crypto Support',
          viewBox: '0 0 576 512',
          pathData: 'M0 112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112zm48 16v272h480V128H48zm96 64h288v32H144v-32zm0 64h288v32H144v-32z'
        },
        // {
        //   id: 5,
        //   title: 'Free Swap',
        //   description: 'Yes, For Minimum Deposit $1.000',
        //   viewBox: '0 0 512 512',
        //   pathData: 'M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v64H480z'
        // },
        {
          id: 6,
          title: 'Affiliate Partner',
          description: 'Yes',
          viewBox: '0 0 640 512',
          pathData: 'M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z'
        },
        {
          id: 7,
          title: 'Leverage Max',
          description: '1:25',
          viewBox: '0 0 448 512',
          pathData: 'M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z'
        },
        {
          id: 8,
          title: 'Commission',
          description: 'Start from $7.0',
          viewBox: '0 0 512 512',
          pathData: 'M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z'
        },
        {
          id: 9,
          title: 'Copy Trade',
          description: 'Yes',
          viewBox: '0 0 448 512',
          pathData: 'M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z'
        }
      ]
    }
  }
}
</script>

<style scoped>
.trading-conditions {
  padding: 60px 20px;
  background: #f8f9fa;
}

.trading-conditions .section-header {
  text-align: center;
  margin-bottom: 60px;
}

.trading-conditions .section-header .main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 15px;
  text-transform: none;
  letter-spacing: normal;
}

.trading-conditions .section-header .subtitle {
  font-size: 1.2rem;
  font-weight: 400;
  color: #7f8c8d;
  margin: 0;
  font-style: normal;
}

.trading-conditions .conditions-grid {
  max-width: 1200px;
  margin: 0 auto;
}

.trading-conditions .conditions-grid .grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.trading-conditions .condition-card {
  background: white;
  border: 1px solid #e1e8ed;
  border-radius: 8px;
  padding: 25px;
  display: flex;
  align-items: center;
  gap: 20px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.trading-conditions .condition-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-color: #b8860b;
}

.trading-conditions .condition-card .icon-container {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  background-color: #f5f3f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.trading-conditions .condition-card .icon-container .condition-icon {
  width: 32px;
  height: 32px;
  fill: #b8860b;
}

.trading-conditions .condition-card .content-container {
  flex: 1;
}

.trading-conditions .condition-card .content-container .condition-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 8px 0;
  text-transform: none;
  letter-spacing: normal;
}

.trading-conditions .condition-card .content-container .condition-description {
  font-size: 0.95rem;
  color: #5a6c7d;
  margin: 0;
  line-height: 1.4;
  font-weight: 500;
}

@media (max-width: 768px) {
  .trading-conditions .conditions-grid .grid-container {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .trading-conditions .condition-card {
    padding: 20px;
    gap: 15px;
  }

  .trading-conditions .section-header .main-title {
    font-size: 2rem;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .trading-conditions .conditions-grid .grid-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>